export class ClsAccesoModel {
  public IP: string;

  public EmpresaID: number;

  public Usuario: string;

  public Password: string
}
